import React   from 'react';
import { connect } from 'react-redux';
import { SelectedActions } from './redux/selected_actions';
import StyledView from './styled_view';
import Show from "./show";
import { Group, Panel, Separator, useDefaultLayout } from "react-resizable-panels";

import i18n from 'i18next';

class ViewTree extends StyledView {

	constructor(props) {
		super(props);
		this.state = {
			loading: false, 
			tree: {
				key:     '-',
				id:      null,
				level:   null,
				data:    [], 
				childs:  [],
				hasnext: true, 
				loading: false, 
				open:    true,
				leaf:    0
			},
			linked: null,
			selected_node: null,
		};
		this.showNext  = this.showNext.bind(this);
		this.clickNode = this.clickNode.bind(this);
		
		const view      = this.props.view;
		this.css        = [];
		this.uri_index  = [];
		this.show_index = [];
		this.href_index = [];
		this.linked     = [];

		this.init_indexes(view);

		if (view.subtree !== undefined) {
			for (let i = 0; i < view.subtree.length; i++) {
				this.init_indexes(view.subtree[i]);
			}
		}
	}

	init_indexes(view) {
		const show = this.findShowIndex(view.col);
		this.show_index.push(show);
		this.href_index.push(this.findHrefIndex(view.col));
		this.uri_index.push(this.findUriIndex(view.col));
		this.css.push(this.createCss(view.col[show]));
		this.linked.push(view.link_view || '0');
	}

	findUriIndex(cols) {
		for (let i = 0; i < cols.length; i++) {
			if (cols[i].col_uri === 'true') {
				return i;
			}
		}
		return 0;
	}

	findShowIndex(cols) {
		for (let i = 0; i < cols.length; i++) {
			if (cols[i].col_show === 'true')	{
				return i;
			}
		}
		return 0;
	}

	findHrefIndex(cols) {
		for (let i = 0; i < cols.length; i++) {
			if (cols[i].hasOwnProperty('link_col') && cols[i].link_col)	{
				for (let j = 0; j < cols.length; j++) {
					if (cols[j].col_field === cols[i].link_col) {
						return j;
					}
				}
			}
		}
		return -1;
	}

	componentDidMount() {
		this.loadData(this.state.tree);
	}

	selectTreeNode(node) {
		this.props.onSelected(node);
		this.setState({selected_node: node.key});
		this.loadLinkedData(node);
	}

	isLinkedTree() {
		return this.getTreeWidth() < 100;
	}

	clickNode(e, node) {
		e.preventDefault();
		const clickX = this.getClickPosition(e);
		if (clickX >= 0 && this.isLinkedTree()) {
			// Клик в название и задано отображение связанного представления.
			// Подгружаем связанное представление.
			this.selectTreeNode(node);
		} else {
			// Клик в плюс-минус или связанное представление не задано.
			// по первому клику в ноду загружаем ее данные
			// затем сворачиваем/разворачиваем список
			if (node.hasnext && node.childs.length === 0) {
				this.loadData(node);
			} else {
				node.open = !node.open;
				this.setState({tree: this.state.tree});
			}
		}
	}

	getClickPosition(e) {
		const rect = e.target.getBoundingClientRect();
		return e.clientX - rect.left;
	}

	showNext(e, node) {
		e.preventDefault();
		this.loadData(node);
	}

	// загрузка списка дочерних узлов элемента
	loadData(node) {
		const tree   = this.state.tree;
		node.loading = true;
		this.setState({
			tree:    tree, 
			loading: true
		});
		const view_id = this.props.view.id;
		const offset  = node.childs.length;
		this.props.model.getTreeData(view_id, offset, node.level, node.id)
			.then(response => {
				const l          = Math.min(node.level * 1, this.uri_index.length - 1);
				const uri_index  = this.uri_index[l];
				const show_index = this.show_index[l];
				const href_index = this.href_index[l];
				const nextLevel  = node.level + 1;
				response.data.map((row) => {
					node.childs.push({
						key:     node.key + '-' + row[uri_index],
						level:   nextLevel, 
						id:      row[uri_index],
						data:    row[show_index],
						href:    href_index >= 0 ? row[href_index] : null,
						childs:  [],
						hasnext: true, 
						loading: false,
						open:    false,
						leaf:    parseInt(row.pop())
					});
				});
				node.hasnext = response.hasnext;
				node.loading = false;
				node.open    = true;
				this.setState({
					tree:    tree, 
					loading: false
				});
				if (node.id === null && node.childs.length && this.isLinkedTree()) {
					this.selectTreeNode(node.childs[0]);
				}
			});
	}

	node_is_not_linked(node) {
        return !this.linked[this.getNodeLevel(node)];
	}

	getNodeLevel(node) {
		return Math.min(node.level - 1, this.uri_index.length - 1);
	}

	loadLinkedData(node) {
		const linked = this.linked[this.getNodeLevel(node)];
		if (this.node_is_not_linked(node)) {
			this.setState({linked: null})
		} else if (this.state.linked === null || this.state.linked.filter.value !== node.id) {
			if (! (this.isLinkedTree() && this.state.linked && this.state.linked.linked_id === linked)) {
				this.setState({linked: null});
				this.props.model.getLinkedView(linked)
					.then(response => {
						this.setState({
							linked: {
								linked_id: response.view.type === 'graph' ? linked : null,
								view: response.view,
								filter: {
									field: this.props.model.getLinkedColumn(linked),
									value: node.id
								}
							}
						});
					});
			}
		}
	}

	getTreeStyle() {
		return {'width': this.getTreeWidth() + '%'}
	}

	getTreeWidth() {
		if (this.props.view.hasOwnProperty('tree_width')) {
			return parseInt(this.props.view['tree_width']);
		} else {
			return 100;
		}
	}

	getViewId() {
		if (this.props.view && this.props.view.hasOwnProperty('id')) {
			return this.props.view['id'];
		} else {
			return "SetupView";
		}
	}

	renderLinkedView(linked) {
		if (linked !== null) {
			return (<Show
				model  = {this.props.model}
				view   = {linked.view}
				filter = {linked.view.type === 'multi' ? linked.filter : {
					field: this.props.model.getLinkedColumn(linked.filter.field[0]),
					value: linked.filter.value
				}}
			/>);
		}
	}

	renderChilds(node) {
		return (<ul className='tree'>
			{node.childs.map((child, key) => (
				<li key={key}>
					{this.renderElem(child)}
					{child.childs.length && child.open ? this.renderChilds(child) : ''}
				</li>
			))}
			{node.hasnext && this.renderExtra(node)}
		</ul>);
	}

	renderElem(node) {
		const l = this.getNodeLevel(node);
		return (
			<div style={this.css[l]}>
				<div
					className = {
						(node.leaf === 0 ?
							(
								this.node_is_not_linked(node) ?
									'leaf-node' :
									'linked-node leaf-node'
							) :
							(node.open ? 'node-open' : 'node-close')
						) + (node.key === this.state.selected_node ? ' selected-node' : '')
					}
					onClick   = {(e) => this.clickNode(e, node)}
				>{this.renderNode(node)}</div>
				{this.renderHref(node.href)}
			</div>
		);
	}

	renderNode(node) {
		return node.data + (node.leaf === 0 ? '' : '(' + node.leaf + ')');
	}

	renderHref(href) {
		if (href) {
			return (<a href={href} target="_blank" className="ext-link"/>);
		}
	}

	renderExtra(node) {
		if (node.loading) {
			return (<li>{i18n.t('view.loading')}</li>);
		}
		return (
			<li>
				<a onClick={(e) => this.showNext(e, node)}
				style={{
					cursor:         'pointer',
					color:          '#ccc',
					textDecoration: 'none!important', 
				}}
				>
					{i18n.t('view.buttons.show_more')}
				</a>
			</li>
		);
	}

	renderDebugInfo(linked) {
		if (document.title === 'Development' && linked) {
			return (<p>
				linked_filter: '{JSON.stringify(linked.filter)}'
			</p>);
		}
	}


	render() {
	        //console.log("view_tree.js debug:", this);
		if (this.isLinkedTree()) {
			return (
				<div className='view-tree' style={this.getTableStyle()}>
					<Group
						direction="horizontal"
						defaultLayout ={(()=>{
							const saved = Number(localStorage.getItem("splitPos-" + this.getViewId()));
							const leftSize = Number.isFinite(saved) ? saved: 10;
							const layout = {"left_tree": leftSize, "detail": 100-leftSize};
							return layout;
						})()}
						onLayoutChange={(sizes) => {
							localStorage.setItem("splitPos-" + this.getViewId(), String(sizes["left_tree"]));
						}}
					>
					<Panel
						id="left_tree"
						minSize="10%"
						maxSize="90%"
						className="view-tree-container"
					>
						{this.renderChilds(this.state.tree)}
					</Panel>

					<Separator className="split-handle" />

					<Panel id="detail" className="view-linked-container">
						{this.renderDebugInfo(this.state.linked)}
						{this.renderLinkedView(this.state.linked)}
					</Panel>	
					</Group>
				</div>
			);
		} else {
			return (
				<div className='view-tree' style={this.getTableStyle()}>
					<div className='view-tree-container' style={this.getTreeStyle()}>
						{this.renderChilds(this.state.tree)}
					</div>
				</div>
			);
		}
	}

}

export default connect(
  null,
  dispatch => ({
    onSelected (node){
		  //console.log("view_tree.js", node, dispatch);
      return dispatch(SelectedActions.SELECTED(node.id));
    },
  })
)(ViewTree);
